import { GET_FAILURE, GET_REQUEST, GET_SUCCESS } from "../actionTypes"

export const get_request=()=>{
    return {type:GET_REQUEST}
}


export const get_failure=()=>{
    return {type:GET_FAILURE}
}

export const get_success=(payload)=>{
  
    return {type:GET_SUCCESS,payload}
}